import * as UserService from "../apis/mbcService";
import {clearErrors, receiveErrors} from "./error";
import {toast} from "react-toastify";
import _ from 'lodash';

import {
  ADD_MIND_BODY_CONNECTION,
  INCREMENT,
  LOAD_CONNECTION_LIST,
  LOGOUT_CURRENT_USER,
  RECEIVE_CURRENT_USER,
  SELECTED_OPTION,
  SET_NAVIGATION_DRAWER,
  SET_PROGRESS_BAR
} from "./actionTypes";
import axios from "axios";

export const setProgressBar = (isOpen) => {
  return async (dispatch) => {
    dispatch({type: SET_PROGRESS_BAR, payload: isOpen});
  };
};

export const setNavigationDrawer = (isOpen) => {
  return async (dispatch) => {
    dispatch({type: SET_NAVIGATION_DRAWER, payload: isOpen});
  };
};

export const toastToSuccessAction = (message) => {
  return function (dispatch) {
    dispatch({
      type: INCREMENT
    });
    toast.success(message);
  };
};

export const toastToFailureAction = (message) => {
  return function (dispatch) {
    dispatch({
      type: INCREMENT
    });
    toast.error(message);
  };
};

const receiveCurrentUser = user => ({
  type: RECEIVE_CURRENT_USER,
  payload: user
});

export const setSelectedOption = option => ({
  type: SELECTED_OPTION,
  payload: {id: _.isEmpty(option) ? "" : option._id}
});

const logoutCurrentUser = () => ({
  type: LOGOUT_CURRENT_USER
});

export const login = user => async (dispatch) => {
  setProgressBar(true);
  return await UserService.login(user)
    .then(response => {
      if (response.status === 200) {
        dispatch(clearErrors());
        setProgressBar(false);
        return dispatch(receiveCurrentUser(response.data));
      } else {
        setProgressBar(false);
        return dispatch(receiveErrors(response.data));
      }
    }).catch(error => {
      console.log(error);
    })
};

export const changePassword = (userId, currentPassword, newPassword) => async (dispatch) => {
  setProgressBar(true);
  const response = await UserService.changePassword(userId, currentPassword, newPassword);
  if (response.status === 200) {
    dispatch(clearErrors());
    setProgressBar(false);
    dispatch(toastToSuccessAction("Successfully changed password"));
    return dispatch(receiveCurrentUser(response.data));
  } else {
    setProgressBar(false);
    return dispatch(receiveErrors(response.data));
  }
};

export const forgotPassword = (email) => async (dispatch) => {
  setProgressBar(true);
  const response = await UserService.forgotPassword(email);
  if (response.status === 200) {
    setProgressBar(false);
    dispatch(toastToSuccessAction("Successfully changed password"));
    return dispatch(receiveErrors(response.data));
  } else {
    setProgressBar(false);
    return dispatch(receiveErrors(response.data));
  }
};

export const signup = user => async dispatch => {
  setProgressBar(true);
  const response = await UserService.register(user);
  const data = await response.json();
  if (response.ok) {
    dispatch(clearErrors());
    setProgressBar(false);
    return dispatch(receiveCurrentUser(data));
  }
  setProgressBar(false);
  return dispatch(receiveErrors(data));
};

export const logout = () => async dispatch => {
  setProgressBar(true);
  const response = await UserService.logout();
  const data = await response;

  if (response.ok) {
    setProgressBar(false);
    return dispatch(logoutCurrentUser());
  }
  setProgressBar(false);
  return dispatch(receiveErrors(data));
};

export const loadConnections = (connectionList) => ({
  type: LOAD_CONNECTION_LIST,
  payload: connectionList
});


export const loadMbConnections = (connections) => ({
  type: ADD_MIND_BODY_CONNECTION,
  payload: connections
});

export const getConnections = () => async dispatch => {
  setProgressBar(true);
  return await axios({
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'withCredentials': 'true'
    },
    method: 'GET',
    url: '/api/v1/connections',
  })
    .then(response => {
      setProgressBar(false);
      return dispatch(loadConnections(response.data));
    })
    .catch(err => {
      setProgressBar(false);
      console.log((err.response));
    });
};

export const getConnectionsForUser = (userId) => async dispatch => {
  setProgressBar(true);
  return await axios({
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'withCredentials': 'true'
    },
    method: 'GET',
    url: `/api/v1/userConnections/${userId}`,
  })
    .then(response => {
      setProgressBar(false);
      return dispatch(loadMbConnections(response.data.connections));
    })
    .catch(err => {
      setProgressBar(false);
      console.log(err.response);
    });
};

export const setConnectionsForUser = (userId, physicalIssueId) => async dispatch => {
  setProgressBar(true);
  return await axios({
    headers: {
      'Content-Type': 'application/json',
      'Accept': 'application/json',
      'withCredentials': 'true'
    },
    data: {
      userId,
      physicalIssueId
    },
    method: 'POST',
    url: `/api/v1/userConnections`,
  })
    .then(() => {
      setProgressBar(false);
      dispatch(toastToSuccessAction("Successfully added connection"));
      return dispatch(getConnectionsForUser(userId));
    })
    .catch(err => {
      setProgressBar(false);
      Object.values(err.response.data['errors']).forEach(message => {
        if (message["userConnections"]) {
          dispatch(toastToFailureAction(message["userConnections"]));
        } else if (message["physicalIssueId"]) {
          dispatch(toastToFailureAction(message["physicalIssueId"]));
        }
      });
      console.log(err.response)
    });
};